import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="modern-footer" 
      id="modern-footer"
      style={{
        '--grid-bg': `url('/grid.png')`
      }}
    >
      <div className="container">
        <div className="footer-content">
          <div className="footer-links">
            <a href="https://adx-hub.com/imprint">Imprint</a>
            <a href="https://industrialdigitaltwin.org/en/privacy">Privacy Policy</a>
          </div>
          <div>
            <img 
              src="/IDTA_Logo_Grey_Web_M.png" 
              alt="IDTA Logo" 
              style={{ height: '40px', filter: 'brightness(0) invert(1)' }}
            />
          </div>
        </div>
        <div className="footer-separator"></div>
        <div className="footer-bottom">
          <p>&copy; 2025 Industrial Digital Twin Applications GmbH. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
